import React, { useEffect, useState } from "react";
import "./CISnippet.css";
import Prism from "prismjs";
import Code from "./code/Code";
import Message from "./message/Message";
import Logo from "../../../common/logo/Logo";

function CISnippet() {
  const code = `
    name: GitVersioniser
    on:
      push:
        branches:
          - main
          - master
    jobs:
      repository_versioning:
        runs-on: ubuntu-latest
        name: Repository Versioning via GitVersioniser
        steps:
          - name: Repository Checkout
            uses: actions/checkout@v3
            with:
              path: target_repository
              fetch-depth: 0
          - name: Running GitVersioniser
            id: GitVersioniser
            uses: luzkan/GitVersioniser@v0
            with:
              # ===========================
              #        Credentials
              # ---------------------------
              # Versioniser Git Credentials
              # ----
              versioniser_username: "GitVersioniser"
              versioniser_email: "luzkan.gitversioniser@github.com"
    
              # ===========================
              #          Patterns
              # ---------------------------
              # Increment Tags
              # ----
              commit_pattern_increment_tags: "HashtagExplicit"
              # ---------------------------
              # Change Tags
              # ----
              commit_pattern_change_tags: "All"
      
              # ===========================
              #          Routines
              # ---------------------------
              # Versioning
              # ----
              routine_version: "VersionTagInCommitsTillLastGitVersioniserCommit"
              # ---------------------------
              # Contributing
              # ----
              routine_should_contribute: "IfNewVersionIsBuildOrHigher"
              routine_commiting: "PushOriginAmend"
              # ---------------------------
              # Commit Message
              # ----
              routine_commit_message_describe_changes: "WithEmoji"
              routine_commit_message_format_version_tag: "FullButOnlyDigits"
              routine_commit_message_place_version_tag: "Prefix"
              routine_commit_message_summarize_changes: "WithEmojiCounted"
              # ---------------------------
              # Tagging
              # ----
              routine_tagging: "Regular"
              routine_prefix_tag_with_v: "Always"
              # ---------------------------
              # Changelog Handling
              # -----
              routine_changelog: "CommitChangeTags"
              # ---------------------------
              # File Versioning
              # ----
              routine_file_updater: "VersioniseFiles"
              versioned_files: ""
              
    `;

  const [alert, setAlert] = useState(false);
  const handleClick = () => {
    navigator.clipboard.writeText(code);
    setAlert(true);
  };

  return (
    <header className="app-header">
      <div className="app-container features-container">
        <div className="logo-box" style={{ marginBottom: "3rem" }}>
          <Logo navigateTo={"/GitVersioniser/start"} />
        </div>
        <div className="logo-box" style={{ marginBottom: "3rem" }}>
          <p>
            .github/workflows/GitVersioniser.yml
          </p>
        </div>

        <Code code={code} />
        <div className="logo-box">
          <p
            className="clickable"
            onClick={() => {
              handleClick();
            }}
          >
            copy
          </p>
        </div>
        <div
          className="logo-box"
          style={{ marginBottom: "3rem", fontSize: "2rem", height: "2.1rem" }}
        >
          {alert ? <Message setAlert={setAlert} /> : ""}
        </div>
      </div>
    </header>
  );
}

export default CISnippet;
